<template>
  <div class="entry-history-dialog">
    <el-dialog custom-class="with-title large" :title="title" :visible.sync="visible" :before-close="beforeClose">
      <div v-loading="loading">
        <div class="mb-x1" layout layout-align="space-between-center">
          <entry-history-table
            :entries="entryHistories"
            :sortBy="options.sortBy"
            @sorting="onChangeSortBy"
          ></entry-history-table>
        </div>
        <div class="mt-x2" layout layout-align="space-between-center">
          <pagination
            flex="1"
            :total="options.total"
            :pagingNo="options.pagingNo"
            :limitCount="options.limitCount"
            @paging="onChangePaging"
          ></pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import EntryHistoryTable from '@/client/components/_atoms/entry_history_table'
import Pagination from '@/client/components/_atoms/pagination'
import Util from '@/client/core/util'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTwitterCampaignEntryHistoryStore } from '@/client/store/useTwitterCampaignEntryHistoryStore'

export default defineComponent({
  data() {
    return {
      title: '',
      accountId: 0 as 0 | string,
      campaignAccountId: 0,
      isWinner: 0,
      visible: false
    }
  },
  components: {
    Pagination,
    EntryHistoryTable
  },
  computed: {
    ...mapState(useSystemStore, {
      groupId: state => state.currentGroup?.id
    }),
    ...mapState(useTwitterCampaignEntryHistoryStore, {
      params: state => state.params,
      options: state => ({
        sortBy: state.params.sortBy,
        pagingNo: state.params.pagingNo,
        limitCount: state.params.limitCount,
        total: state.total
      }),
      loading: state => state.loading,
      entryHistories: state => state.entryHistories
    })
  },
  watch: {
    params() {
      this.fetchEntryHistory()
    }
  },
  methods: {
    ...mapActions(useTwitterCampaignEntryHistoryStore, ['reset', 'fetchEntryHistory', 'setParams']),
    /**
     * 変更イベント
     * @param {any} payload ページ
     */
    onChangePaging(payload: any) {
      this.setParams(payload)
      Util.scrollToTop()
    },

    /**
     * ソートを変更イベント
     * @param {any} sortBy ソート
     */
    onChangeSortBy(payload: any) {
      if (this.params.sortBy === payload.sortBy) {
        return
      }
      this.setParams(payload)
    },

    /**
     * ダイアログをあく
     * @param {string} accountName account name
     * @param {string} accountId account id
     * @param {number} isWinner is winner
     */
    open(
      accountName: string,
      campaignAccountId: number,
      accountId: string,
      isWinner: number,
      campaignId: number,
      campaignStartDatetime: string
    ) {
      this.visible = true
      this.accountId = accountId
      this.isWinner = isWinner
      this.campaignAccountId = campaignAccountId

      if (isWinner) {
        this.title = `${accountName} さんの当選履歴`
      } else {
        this.title = `${accountName} さんの応募履歴`
      }

      this.setParams({
        accountId: this.accountId,
        groupId: this.groupId,
        campaignAccountId: this.campaignAccountId,
        isWinner: this.isWinner,
        campaignId,
        campaignStartDatetime
      })
    },

    /**
     * ダイアログ閉じるイベント
     */
    beforeClose(done) {
      this.title = ''
      this.accountId = 0
      this.isWinner = 0
      this.reset()
      done()
    }
  }
})
</script>
